import { captureAuthLinkType } from './auth/inviteLinkGuard';
import { createPortalSupabaseClient } from './supabase';

// Captured before the client below is constructed — see
// inviteLinkGuard.ts's module doc for why the ordering matters (the raw
// invite/recovery URL params must be read before GoTrue's
// `detectSessionInUrl` asynchronously strips them).
captureAuthLinkType();

export const supabase = createPortalSupabaseClient(true);
